/**
 * Signing Account Provider enum - defines the different wallet providers supported
 * for external signing accounts that can sign transactions.
 *
 * This enum is shared across domains to maintain consistency in provider identification.
 */
export var SigningAccountProvider;
(function (SigningAccountProvider) {
    /* METAMASK          = 'metamask',
    WALLETCONNECT     = 'walletconnect',
    COINBASE_WALLET   = 'coinbase_wallet', */
    SigningAccountProvider["DFNS"] = "DFNS";
    // CUSTODIAL         = 'custodial'
    SigningAccountProvider["PERS_INTERNAL"] = "PERS_INTERNAL"; // Internal PERS managed signing accounts
})(SigningAccountProvider || (SigningAccountProvider = {}));
//# sourceMappingURL=signing-account-provider.enum.js.map